import axios from "axios";
import { queryParams } from "../../../utils/queryParams";

const instance = axios.create({
  baseURL: queryParams.apiVersion + "pages/sales_activity/lead_status"
});

export const api = {
  getFilters(params) {
    return instance.get("/get_filters", params);
  },
  getData(params) {
    return instance.post("/get_table", params);
  },
  getLeads(params) {
    return instance.get("/leads", params);
  },
  getFirstOpenBookings(params) {
    return instance.get("/first_open_bookings", params);
  },
  getFirstCompletedBookings(params) {
    return instance.get("/first_completed_bookings", params);
  },
  getFirstEnrollment(params) {
    return instance.get("/first_enrollments", params);
  }
};
